import { LegalLayout } from "./layout";

export default function Terms() {
  return (
    <LegalLayout title="Terms of Service" lastUpdated="March 23, 2026">
      <p>
        By creating an account or using Lerni, you agree to these Terms of Service. Please read them carefully.
      </p>

      <h2>1. Who Can Use Lerni</h2>
      <p>
        You must be at least 13 years old to use Lerni. By using the service, you confirm that the information you provide is accurate and that you have the authority to agree to these terms.
      </p>

      <h2>2. Acceptable Use</h2>
      <p>You agree not to use Lerni to:</p>
      <ul>
        <li>Upload or process content that is illegal, harmful, threatening, abusive, or violates any applicable law.</li>
        <li>Infringe on the intellectual property rights of others.</li>
        <li>Attempt to reverse-engineer, scrape, or exploit the platform in ways not intended by its design.</li>
        <li>Use the service for any purpose other than personal study and learning.</li>
      </ul>

      <h2>3. Your Content</h2>
      <p>
        You are solely responsible for the files and text you upload to Lerni. By uploading content, you confirm that you have the right to do so. Lerni does not claim ownership of your content, but you grant us a limited license to process it for the purpose of generating your study materials.
      </p>

      <h2>4. AI Limitations</h2>
      <p>
        Lerni uses AI models to generate summaries, flashcards, quizzes, and chat responses. These outputs are generated automatically and may not always be 100% accurate, complete, or suitable for every use case. You should review AI-generated content critically and not rely on it as a substitute for professional advice or authoritative sources.
      </p>

      <h2>5. Subscription and Usage Limits</h2>
      <ul>
        <li>Your plan includes a monthly character limit that resets at the start of each billing cycle.</li>
        <li>Unused characters do not carry over to the next month.</li>
        <li>If you exceed your plan's limits, you will need to upgrade or wait until your next billing cycle.</li>
        <li>Lerni reserves the right to adjust plan limits with reasonable notice.</li>
      </ul>

      <h2>6. Account Termination</h2>
      <p>
        You may cancel your account at any time. Lerni reserves the right to suspend or terminate accounts that violate these terms, engage in abuse, or pose a risk to other users or the platform. In cases of serious violations, termination may occur without prior notice.
      </p>

      <h2>7. Service Availability</h2>
      <p>
        Lerni is provided on an <strong>"as-is"</strong> and <strong>"as-available"</strong> basis. We strive for high availability but do not guarantee uninterrupted or error-free service. We may modify, suspend, or discontinue features at any time.
      </p>

      <h2>8. Limitation of Liability</h2>
      <p>
        To the maximum extent permitted by law, Lerni and its team are not liable for any indirect, incidental, special, or consequential damages arising from your use of — or inability to use — the service. This includes loss of data, study outcomes, or business losses.
      </p>

      <h2>9. Changes to These Terms</h2>
      <p>
        We may update these Terms of Service from time to time. Continued use of Lerni after changes are posted constitutes your acceptance of the updated terms.
      </p>

      <h2>10. Contact</h2>
      <p>
        Questions about these terms? Contact us at <strong>lernisupport@gmail.com</strong>.
      </p>
    </LegalLayout>
  );
}
